// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8511 ? "2e6f1b4f" : chunkId) + "." + {"4766":"46c628461631e3b2","8196":"7a1a2f22a430ea37","8511":"cec72ef733fc8a59"}[chunkId] + ".js";
};